import { Injectable } from '@angular/core';
import { HttpClientService } from '../lib/http/http-client.service';
import { CoBuyerModel, ContractCOBuyer, CoBuyerInfoModel } from '../models/CoBuyerModel';
import { Utilities } from '../Utilities';
import { ServiceRequestModel } from '../models/ServiceRequestModel';
import { CommonService } from '../shared/services/common.service';
import { environment } from '../../environments/environment';

@Injectable()
export class CoBuyerService {

  constructor(public http: HttpClientService,
    private commonService: CommonService) {
  //   this.commonService.getServiceRequestFileConfig(environment.serviceRequestFileCount).subscribe(x =>
  //     this.commonService.serviceRequestFileCount.next(x && x.Value ? x.Value : 5)
  //   );
  //   this.commonService.getServiceRequestFileConfig(environment.ServiceRequestImageSizePerFile).subscribe(x =>
  //     this.commonService.serviceRequestImageSizePerFile.next(x && x.Value ? x.Value : 4)
  //   );
  //   this.commonService.getServiceRequestFileConfig(environment.ServiceRequestVideoSizePerFile).subscribe(x =>
  //     this.commonService.serviceRequestVideoSizePerFile.next(x && x.Value ? x.Value : 4)
  //   );
  //   this.commonService.getServiceRequestFileConfig(environment.serviceRequestFileType).subscribe(x =>
  //     this.commonService.serviceRequestFileType.next(x && x.Value ? x.Value : "image/png,image/jpg")
  //   );
   }
  public getGetCoBuyerListByCommunityLotId(communityLotId: number,contractID:number) {
    return this.http.get('/CoBuyer/GetCoBuyerListByCommunityLotIdForPortal?CommunityLotId=' + communityLotId+"&ContractID=" + contractID);
  }

  public getCoBuyerInfoById(coBuyerId: number) {
    return this.http.get('/CoBuyer/GetCoBuyerInfoById?coBuyerId=' + coBuyerId);
  }

  public saveCoBuyerInfo(CoBuyerInfoModel: any) {
    return this.http.post('/CoBuyer/SaveCoBuyerInfo',CoBuyerInfoModel);
  }

  public getCountry() {
    return this.http.get('/CoBuyer/GetCountyList');
  }
  public CheckCoBuyerEmailAddress(email: any,CobuyerId: number) {
    return this.http.get('/CoBuyer/CheckCoBuyerEmailAddress?email='+email+"&CobuyerId="+CobuyerId);
  }

  public SendMailToCoBuyerCredential(CobuyerId:number,communityLotId: number,CreatedFrom:string) {
    return this.http.get('/CoBuyer/SendMailToCoBuyerCredential?CobuyerId='+CobuyerId+"&CommunityLotId=" + communityLotId+"&CreatedFrom=" + CreatedFrom);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/Co-Buyer.service.ts